import React from 'react';

import ImageYatHandPurpleChrome from '@pkg/assets/images/yat-hand-purple-chrome.png';

import { Image, StyledFallback } from './styles';

export interface FallbackProps {
    id?: string;
    altText?: string;
}

// The `ImageYatHandPurpleChrome` asset will also take time to load,
// so we could get an abrupt flash before the asset is available.
export function Fallback({ id, altText }: FallbackProps) {
    return (
        <StyledFallback>
            <Image src={ImageYatHandPurpleChrome} id={id} alt={altText} />
        </StyledFallback>
    );
}
